module.exports = __webpack_public_path__ + "static/media/Gallery_3-min.2ce007b8.jpg";